nc_initScrollClass('.header', '.header', 'fixed');

$(window).load(function () {
  $("html").addClass("window-load");
});